// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"CareerImgComponentForMobile_imgStyle__3H6k8"};